import {put, take} from "redux-saga/effects";
import {closeDialog, showDialog} from "../actions";
import {INotificationDialogOptions} from "../types";

export function* showAlert(title: string, text?: string) {
    yield put(showDialog({
        type: 'NotificationDialog',
        options: {
            title,
            text
        } as INotificationDialogOptions
    }));

    yield take(closeDialog);
}